// @flow
import * as React from 'react';
import Textarea from 'components/Textarea';
import Field from './Field';

const TextAreaField = ({
  name,
  label,
  description,
  placeholder,
  maxLength,
  ...props
}: {
  name: string,
  label?: string,
  description?: string,
  onUpdateValue?: string => void,
  placeholder?: string,
  maxLength?: number
}) => (
  <Field
    inputProps={props}
    name={name}
    label={label}
    description={description}
    renderInput={({ value, id, qaId, hasError, updateValue }) => (
      <Textarea
        id={id}
        name={name}
        value={value}
        hasError={hasError}
        data-qa-id={qaId}
        maxLength={maxLength}
        onChange={e => {
          updateValue(e.target.value);
          if (props.onUpdateValue) {
            props.onUpdateValue(e.target.value);
          }
        }}
        placeholder={placeholder}
        {...props}
      />
    )}
  />
);

export default TextAreaField;
